export default function GradientButton({
  children,
  onClick,
  type = 'button',
  customStyles,
}: {
  children: React.ReactNode;
  customStyles?: React.CSSProperties;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
}) {
  return (
    <button
      className="px-3 py-1 rounded-md hover:brightness-94 color-white text-md font-inter-display"
      style={{
        ...customStyles,
        background: 'linear-gradient(rgb(48, 82, 255) 0%, rgb(21, 43, 150) 100%)',
      }}
      onClick={onClick}
      type={type}
    >
      {children}
    </button>
  );
}
